import React from "react";
import { Container } from "react-bootstrap";
import CompanyAddressDetails from "../components/Contact/CompanyAddressDetails";
import CompanyLocationMap from "../components/Contact/CompanyLocationMap";

const Contact = () => {
  return (
    <Container fluid>
      <CompanyLocationMap />
      <CompanyAddressDetails />
    </Container>
  );
};

export default Contact;
